import React from 'react';

export const TriangleDownPointIcon: React.FC = ({width}: any) => (
    <svg
        width={width}
        height={width}
        viewBox={`0 0 20 18`}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="M10 18L1.57361e-06 -1.74846e-06L20 0L10 18Z" fill="currentColor" />
    </svg>
);

export default TriangleDownPointIcon;
